var _path;
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var MinusSquare = function MinusSquare(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor,
    className = _ref.className;
  var minusSquareIconId = String(Date.now());
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    className: className,
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15 11H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm4 7c0 .551-.448 1-1 1H6c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h12c.552 0 1 .449 1 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z"
    })), /*#__PURE__*/_jsx("mask", {
      id: "icon-".concat(minusSquareIconId),
      width: "18",
      height: "18",
      x: "3",
      y: "3",
      maskUnits: "userSpaceOnUse",
      children: /*#__PURE__*/_jsx("path", {
        fill: !ignoreColor ? color : undefined,
        fillRule: "evenodd",
        d: "M15 11H9c-.55 0-1 .45-1 1s.45 1 1 1h6c.55 0 1-.45 1-1s-.45-1-1-1zm4 7c0 .551-.448 1-1 1H6c-.552 0-1-.449-1-1V6c0-.551.448-1 1-1h12c.552 0 1 .449 1 1v12zM18 3H6C4.346 3 3 4.346 3 6v12c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3V6c0-1.654-1.346-3-3-3z",
        clipRule: "evenodd"
      })
    }), /*#__PURE__*/_jsx("g", {
      mask: "url(#icon-".concat(minusSquareIconId, ")"),
      children: /*#__PURE__*/_jsx("path", {
        fill: !ignoreColor ? color : undefined,
        d: "M0 0H24V24H0z"
      })
    })]
  });
};
export default MinusSquare;